<script lang="ts">
    import { apiBaseURL } from "../../../../config"

    import { onChange } from "../../../components/formComponents/helper"
    import Input from "../../../components/formComponents/Input.svelte"
    import ImageMetaData from "./ImageMetaData.svelte"
    import { isMobile, login, newNotification } from "../../../store"
    import { createEventDispatcher } from "svelte"
    import TaskImageActionRow from "./TaskImageActionRow.svelte"
    export let image: TaskFile, selected: boolean, media: Media
    const dispatch = createEventDispatcher()
</script>

<li class="taskImage">
    <div class="form">
        {#if media}
            <div class="img-wrapper">
                <img
                    src="{`${apiBaseURL}media/${media.id}/${media?.file?.src}`}"
                    alt="Image Preview"
                    class="image"
                    aria-hidden="true"
                />
                <TaskImageActionRow
                    bind:media="{media}"
                    image="{image}"
                    bind:selected="{selected}"
                    on:remove="{() => {
                        dispatch('remove', media.id)
                    }}"
                />
            </div>
            <ImageMetaData image="{media}" />
        {/if}
        <button
            on:click|preventDefault|stopPropagation="{() => {
                if ($login.user.roles.includes('admin')) {
                    image.inMissionProtocol = !image.inMissionProtocol
                } else {
                    newNotification({
                        class: 'error',
                        html: 'Sie haben keine Berechtigung, um Bilder in das Einsatzprotokoll zu übernehmen.',
                    })
                }
            }}"
            class:active="{image.inMissionProtocol}"
            class="imgInProtocoll"
        >
            <img
                src="../../../assets/icons/solar_clipboard-text-outline{image.inMissionProtocol ? '-white' : ''}.svg"
                alt="icon"
            />
            <p>{$isMobile ? "Einsatzprotokoll" : "Bild in Einsatzprotokoll"}</p>
        </button>
        <Input
            placeholder="Kommentar"
            bind:value="{image.comment}"
            onChange="{onChange}"
            onBlur="{(e, valueChanged) => {
                if (valueChanged) image.comment = image.comment.trim()
            }}"
            id="comment"
            type="textarea"
            smallTextarea="{true}"
        />
    </div>
</li>

<style
    lang="less"
    global
>
    @import "../../../../../assets/variables.less";
    li.taskImage {
        width: 100%;
        margin-bottom: 0.9rem;
        .form {
            display: flex;
            flex-direction: column;
            gap: 6px;
            height: 100%;
            .img-wrapper {
                width: 100%;
                aspect-ratio: 1/1;

                img {
                    width: 100%;
                    aspect-ratio: 1/1;
                    object-fit: cover;
                    border-radius: 12px;
                }
                @media @mobile {
                    width: min(200px, 40vw);
                    min-width: 100%;
                    height: 100%;
                    aspect-ratio: unset;
                    img {
                        aspect-ratio: unset;
                        height: 100%;
                    }
                }
                position: relative;
            }
            .imgInProtocoll {
                display: flex;
                padding: 0.6rem;
                align-items: center;
                gap: 0.6rem;
                border-radius: 12px;
                border: 1px solid var(--grey-200);
                background: var(--white-100);
                p {
                    font-family: Inter-Bold;
                    font-size: 0.7rem;
                    font-weight: 700;
                    text-transform: uppercase;
                    color: var(--text-100);
                    text-align: start;
                    @media @mobile {
                        font-size: 0.5rem;
                    }
                }
                &.active {
                    background: var(--confirm-100);
                    border: 1px solid var(--confirm-100);
                    p {
                        color: var(--white-100);
                    }
                }
            }
            @media @mobile {
                display: grid;
                grid-template-columns: 1fr 1fr;
                & > * {
                    &:first-child {
                        grid-column: 1 / 2;
                        grid-row: 1 / 3;
                    }
                    &:nth-child(2) {
                        grid-column: 2 / 3;
                        grid-row: 1 / 2;
                    }
                    &:nth-child(3) {
                        grid-column: 2 / 3;
                        grid-row: 2 / 3;
                    }
                    &:last-child {
                        grid-column: 1 / 3;
                        grid-row: 3 / 4;
                    }
                }
            }
        }
    }

    .h3 {
        display: flex;
        gap: 0.6rem;
    }
    .modal-body {
        height: 70vh;
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        padding: 0.6rem;
        p {
            color: var(--text-100);
        }
    }
</style>
